module.exports = __webpack_public_path__ + "assets/07a060c82188db4fedcd05a2d2bbd231.png";